import { render } from "./DialogAnnotazioneMezzo.vue?vue&type=template&id=148074ba"
import script from "./DialogAnnotazioneMezzo.vue?vue&type=script&lang=js"
export * from "./DialogAnnotazioneMezzo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__